export default __webpack_public_path__ + "static/media/farhansoomro.392836e2.jpg";